import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isClockInClockOutFeatureEnabledSelector = (communityId: number) =>
  createSelector(getUserPermissions, (permissions) => {
    if (permissions?.CLOCK_IN_CLOCK_OUT?.access)
      return (
        permissions.CLOCK_IN_CLOCK_OUT.access.includes('read') &&
        !!permissions.CLOCK_IN_CLOCK_OUT.communities &&
        !!permissions.CLOCK_IN_CLOCK_OUT.communities[communityId] &&
        !!permissions.CLOCK_IN_CLOCK_OUT.communities[communityId].includes('read')
      );
    else return false;
  });
